import { NOTIFICATION_MODAL } from "../../common/actionTypes";
const INITIAL_STATE = {
  notification_modal: { isOpen: false, message: {} },
};

const notificationModalReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }
  switch (action.type) {
    case NOTIFICATION_MODAL: {
      return { ...state, notification_modal: action.payload };
    }
    default:
      return state;
  }
};

export default notificationModalReducer;
